import React from 'react'
import './GeneralCategory.css'
import GeneralCategoryItem from '../GeneralCategoryItem/GeneralCategoryItem'
import { Row, Col, Container } from 'react-bootstrap'
import { shuffle } from 'lodash';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { PiStudentThin, PiVideo, PiShoppingCartSimpleLight } from 'react-icons/pi'
import { useNavigate } from 'react-router';
export default function GeneralCategory() {

    const Styles = [{
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(180deg, #FECF6C 0%, #FFBE70 100%)',
        boxShadow: '0px 2px 25px 0px rgba(254, 205.99999999999997, 108.00000000000001, 0.65)',
        color: '#7C580F',
    },
    {
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(180deg, #AAE181 0%, #89D351 100%)',
        boxShadow: ' 0px 2px 25px 0px rgba(136.99999999999986, 210.99999999999994, 80.99999999999987, 0.42)',
        color: '#2B530D'
    }

    ];

    const nav = useNavigate();
    const shuffledColors = shuffle(Styles);
    return (
        <>

            <div className='general-category'>
                <Container>
                    <div className='general-category-wrapper'>
                        <Row className='general-category-row'>
                            <Col xs={4} onClick={() =>nav('/courses')}>
                                <GeneralCategoryItem title='دوره های آموزشی' desc='آموزش جامع صنایع و خوداشتغالی' icon={<PiStudentThin />} Styles={shuffledColors[0]} />
                            </Col>
                            <Col xs={4} onClick={() =>nav('/courses?f=0')}>
                                <GeneralCategoryItem title='آموزش های رایگان' desc='دسترسی به ده ها ویدیو رایگان و مفید' icon={<PiVideo />} Styles={shuffledColors[1]} />
                            </Col>
                            <Col xs={4} onClick={()=> nav('/products')}>
                                <GeneralCategoryItem title='فروشگاه محصولات' desc='خرید آسان انواع دستگاه و مواد اولیه' icon={<PiShoppingCartSimpleLight />} Styles={shuffledColors[2]} />
                            </Col>
                        </Row>
                    </div>

                </Container>

            </div>
            <div className='general-category-responsive'>
                <Container>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            300: {
                                slidesPerView: 1.5,
                                spaceBetween: 20,
                            },
                            640: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 40,
                            },
                            992: {
                                slidesPerView: 3,
                                spaceBetween: 40,
                            },
                            1400: {
                                slidesPerView: 4,
                                spaceBetween: 40,
                            }
                        }}
                        modules={[Autoplay]}
                        className="mySwiper"
                    >
                        <SwiperSlide  onClick={() =>nav('/courses')}>
                            <GeneralCategoryItem title='دوره های آموزشی' desc='آموزش جامع صنایع و خوداشتغالی' icon={<PiStudentThin />} Styles={shuffledColors[0]} />
                        </SwiperSlide>
                        <SwiperSlide onClick={() =>nav('/courses?f=0')}>
                            <GeneralCategoryItem title='آموزش های رایگان' desc='دسترسی به ده ها ویدیو رایگان و مفید' icon={<PiVideo />} Styles={shuffledColors[1]} />
                        </SwiperSlide>
                        <SwiperSlide onClick={()=> nav('/products')}>
                            <GeneralCategoryItem title='فروشگاه محصولات' desc='خرید آسان انواع دستگاه و مواد اولیه' icon={<PiShoppingCartSimpleLight />} Styles={shuffledColors[2]} />
                        </SwiperSlide>
                    </Swiper>
                </Container>

            </div>
        </>

    )
}
